import { createStore } from 'vuex';

export default createStore({
    state: {
        data: null,
        popular: null
    },
    getters: {
        getMountProps: state => state
    },
    mutations: {
        SET_DATA_FROM_PROPS(state, data) {
            state.data = data;
        },
        SET_POPULAR_FROM_PROPS(state, data) {
            state.popular = data;
        }
    },
    actions: {
        updateDataFromProps({ commit }, data) {
            commit('SET_DATA_FROM_PROPS', data);
        },
        updatePopularFromProps({ commit }, data) {
            commit('SET_POPULAR_FROM_PROPS', data);
        }
    }
});
